<template>
  <div class="cpo-exam container">
    <div class="cpo-exam-header">
      <div class="bgm" style="background-image: url('/img/b907b971d0259c8ee9cf89def64db4664ed2da16.jpg')">
        <h1>中国爱乐乐团社会艺术水平考级</h1>
      </div>
      <div class="selection">
        <h4 class="mr-6">请选择考级类别</h4>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <div class="flex lg2 md3">
              <v-btn color="accent" block depressed tile v-bind="attrs" v-on="on"> {{ $t(instrument) }} <v-icon right large>mdi-chevron-down</v-icon> </v-btn>
            </div>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in types" :key="index" @click="instrument = item.text">
              <v-list-item-title>{{ $t(item.text) }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu top v-if="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="accent" large depressed tile width="180px" class="mx-3" v-bind="attrs" v-on="on">
              {{ $t("examination.level") }} <v-icon right large>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in items" :key="index">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <v-row class="py-10">
      <v-col cols="12" md="4">
        <div class="cpo-exam-card">
          <img src="/img/ffc79009-4944-49a2-9d1b-0cf3a7eede2a.png" style="width: 100%" />
          <div class="card-content"><p>师资培训</p></div>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="cpo-exam-card">
          <img src="/img/7f5f2a82-7a4d-49d0-ae62-c9bd1cfd3c8f.png" style="width: 100%" />
          <div class="card-content"><p>英才爱乐青少年艺术展演</p></div>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="cpo-exam-card">
          <img src="/img/b9a5246f-a96f-4931-a6b2-cf3326d58659.png" style="width: 100%" />
          <div class="card-content"><p>考级教材</p></div>
        </div>
      </v-col>
    </v-row>
    <div class="cpo-exam-about" style="background-image: url('/img/banner-01.png')">
      <div class="about-content">
        <h1>{{ $t("examination.about") }}</h1>
        <div class="layout flex-column-reverse flex-md-row">
          <p>
            2000年5月25日，在中央领导同志和中宣部的关心指导下，在国家广播电影电视总局的领导下，在国家各有关部门的支持下，中国爱乐乐团在原中国广播交响乐团基础上组建成立。中国爱乐乐团是国家级交响乐团，直属于国家广播电视总局，现任团长为李南，余隆担任艺术总监和首席指挥。作为中国年轻且最具活力的交响乐团，乐团以高度的职业化标准，为中国交响乐事业的发展树立起一个挺拔的标杆。中国爱乐乐团的成立成为了中国交响乐事业走向职业化与国际化的标志性事件，作为第一支与世界顶级唱片公司合作、面向全世界发行唱片的中国乐团，第一支举行大规模海外巡演甚至世界巡演的中国乐团，第一支肩负国家使命开启外交破冰之旅的中国乐团，第一支登上世界顶级夏季音乐节舞台的中国乐团，其创新的运营与管理模式打破了以往的陈旧观念，随后被中国各地的乐团争相借鉴与引用。20年来，中国由十几支职业乐团发展到如今近一百支乐团，在国际交响乐发展史上是一大壮举，中国爱乐乐团积累下来的宝贵经验极大地推动了全行业的进步，被视为表率，在中国当代音乐史上写下了浓墨重彩的一笔。
          </p>
          <div class="px-md-6">
            <img src="/img/a7e2da562ac842cbaafeabf51f15g5s6df04.jpeg" />
            <h5 style="color: var(--background-red); text-align: center">中国爱乐乐团2022-2023音乐季</h5>
          </div>
        </div>
      </div>
    </div>
    <h1 class="nav-title">新闻</h1>
    <cpo-news-list :items="news" />
  </div>
</template>

<script>
import CpoNewsList from "@/components/CpoNewsList.vue";
export default {
  components: { CpoNewsList },
  data() {
    return {
      instrument: "examination.instrument",
      level: "",
      categories: [{ text: "乐团新闻", value: "1edc0466-42bd-56bf-953a-124acbe34" }],
      types: [
        { text: "examination.types.piano", value: "piano" },
        { text: "examination.types.cello", value: "cello" }
      ],
      news: []
    };
  },
  created() {
    this.$axios.post("/news/list", { filter: [], sort: [{ field: "date", asc: false }], pageSize: 3 }).then((data) => {
      this.news = data.map((item) => {
        item.category = this.categories.find((c) => c.value == item.category);
        return item;
      });
    });
  }
};
</script>

<style lang="scss">
.cpo-exam {
  .cpo-exam-header {
    color: #fff;
    position: relative;
    margin-left: -12px;
    margin-right: -12px;
    .bgm {
      background-position: top center;
      background-size: cover;
      height: 360px;
      display: flex;
      align-items: center;
      justify-content: center;
      h1 {
        font-size: 26px;
        text-align: center;
      }
    }
    .selection {
      position: absolute;
      left: 16px;
      right: 16px;
      bottom: 16px;
      background: #414141;
      padding: 16px;
      justify-content: center;
      align-items: center;
    }
  }
  .cpo-exam-card {
    img {
      display: block;
    }
    .card-content {
      color: #fff;
      background: var(--background-red);
      padding: 1em;
      text-align: center;
      font-weight: bold;
      font-size: 16px;
      line-height: 2em;
      max-height: 4em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .cpo-exam-about {
    background-size: 100%;
    background-repeat: no-repeat;
    margin-bottom: 16px;
    .about-content {
      background: #f0f0f0;
      padding: 16px;
      h1 {
        color: var(--background-red);
        margin-bottom: 1em;
      }
      p {
        font-size: 16px;
        line-height: 2.5em;
      }
    }
  }
}
@media (min-width: 960px) {
  .cpo-exam {
    .cpo-exam-header {
      margin: 0;
      padding-bottom: 48px;
      .selection {
        display: flex;
        flex-wrap: nowrap;
        left: 64px;
        right: 64px;
        bottom: 0;
        padding: 28px 0;
      }
    }
    .cpo-exam-about {
      padding-top: 12%;
      .about-content {
        padding: 1em;
        img {
          width: 300px;
        }
      }
    }
  }
}
@media (min-width: 1264px) {
  .cpo-exam {
    .cpo-exam-card {
      margin: 0.5em 0;
      .card-content {
        font-size: 20px;
      }
    }
    .cpo-exam-about {
      width: 80%;
      margin: 0 auto;
    }
  }
}
</style>
